const REGIONAL_INDICATOR_A = 0x1f1e6;
const REGIONAL_INDICATOR_Z = 0x1f1ff;

function isImageUrl(value) {
  return /^https?:\/\//i.test(value || "");
}

function flagEmojiToCode(value) {
  const points = Array.from(value || "").map(char => char.codePointAt(0));
  const isRegionalIndicator = point =>
    point >= REGIONAL_INDICATOR_A && point <= REGIONAL_INDICATOR_Z;
  if (points.length !== 2 || !points.every(isRegionalIndicator)) return "";
  return points
    .map(point => String.fromCharCode(point - REGIONAL_INDICATOR_A + 97))
    .join("");
}

// Windows ไม่แสดงอีโมจิธง (เห็นเป็นตัวอักษร เช่น GB) จึงแปลงเป็นรูปธงจากรหัสประเทศ
function getFlagSrc(imageUrl) {
  const value = imageUrl || "";
  if (isImageUrl(value)) return value;
  const code = flagEmojiToCode(value);
  return code ? `https://flagcdn.com/w40/${code}.png` : "";
}

export { getFlagSrc };
